import cleanObject from './cleanObject'

if (typeof window === 'undefined') {
  window = {}
}

export function saveTempToken(token) {
  window.localStorage.setItem('temp_jwt_token', token)
}

export function fetchTempToken() {
  return window.localStorage.getItem('temp_jwt_token')
}

export function removeTempToken() {
  window.localStorage.removeItem('temp_jwt_token')
}

export function setFlashMessage(message) {
  window.localStorage.setItem('flash_message', message)
}

export function getFlashMessage() {
  return window.localStorage.getItem('flash_message')
}

export function removeFlashMessage() {
  window.localStorage.removeItem('flash_message')
}

export function setLocalStorageValue({ key, value }) {
  window.localStorage.setItem(key, value)
}

export function getLocalStorageValue(key) {
  return window.localStorage.getItem(key)
}

export function setLocalStorageValues(token, currentUser) {
  window.localStorage.removeItem('commandeer_token')
  window.localStorage.setItem('bearer_token', token)
  window.localStorage.setItem('email', currentUser.data.email)
  window.localStorage.setItem('mobile', currentUser.data.mobile)
  window.localStorage.setItem('location', currentUser.data.location)
  window.localStorage.setItem('f_name', currentUser.data.f_name)
  window.localStorage.setItem('l_name', currentUser.data.l_name)
  window.localStorage.setItem('username', currentUser.data.username)
  window.localStorage.setItem('orgDetails', JSON.stringify(currentUser.data.orgDetails))
  window.localStorage.setItem(
    'preferredCategoryIds',
    JSON.stringify(currentUser.data.preferredCategoryIds)
  )
  window.localStorage.setItem('user_id', currentUser.data.id)

  if (currentUser.data.avatar_url) {
    window.localStorage.setItem('avatar_url', currentUser.data.avatar_url)
  }
}

export function updateOrgDetails(data = []) {
  window.localStorage.setItem('orgDetails', JSON.stringify(data))
}

export function updateLocalStorageValues(data) {
  window.localStorage.setItem('email', data.email)
  window.localStorage.setItem('mobile', data.mobile)
  window.localStorage.setItem('f_name', data.f_name)
  window.localStorage.setItem('username', data.username)
  window.localStorage.setItem('l_name', data.l_name)
  window.localStorage.setItem('avatar_url', data.avatar_url)
  window.localStorage.setItem('location', data.location)
  window.localStorage.setItem('user_id', data.id)
  window.localStorage.setItem('preferredCategoryIds', JSON.stringify(data.preferredCategoryIds))
  window.localStorage.setItem('orgDetails', JSON.stringify(data.orgDetails))
}

export function getLocalStorageValues() {
  let orgDetails = ''
  let preferredCategoryIds = ''

  try {
    orgDetails = JSON.parse(window.localStorage.getItem('orgDetails'))
  } catch (err) {
    orgDetails = ''
  }

  try {
    preferredCategoryIds = JSON.parse(window.localStorage.getItem('preferredCategoryIds'))
  } catch (err) {
    preferredCategoryIds = ''
  }

  return cleanObject({
    email: window.localStorage.getItem('email'),
    mobile: window.localStorage.getItem('mobile'),
    location: window.localStorage.getItem('location'),
    f_name: window.localStorage.getItem('f_name'),
    l_name: window.localStorage.getItem('l_name'),
    username: window.localStorage.getItem('username'),
    avatar_url: window.localStorage.getItem('avatar_url'),
    orgDetails,
    preferredCategoryIds,
    id: window.localStorage.getItem('user_id')
  })
}

export function clearLocalStorageValues() {
  window.localStorage.removeItem('bearer_token')
  window.localStorage.removeItem('commandeer_token')
  window.localStorage.removeItem('email')
  window.localStorage.removeItem('f_name')
  window.localStorage.removeItem('l_name')
  window.localStorage.removeItem('username')
  window.localStorage.removeItem('mobile')
  window.localStorage.removeItem('user_id')
  window.localStorage.removeItem('avatar_url')
  window.localStorage.removeItem('orgDetails')
}

export function identifyVisitorAsOrgMember(orgId) {
  if (!orgId) return true
  if (orgId === '') return true

  window.localStorage.setItem('identified_as_member_of_org_id', `${orgId}`)
}

export function getOrgMemberAssociationId() {
  return window.localStorage.getItem(`identified_as_member_of_org_id`)
}

export function updateCommanderToken(token) {
  window.localStorage.setItem('commandeer_token', token)
  window.location.reload()
}

export function removeCommanderToken() {
  window.localStorage.removeItem('commandeer_token')
  window.location.reload()
}

export function fetchCommanderToken() {
  return window.localStorage.getItem('commandeer_token')
}
